const mutations = {
  change_token(state) {
    state.age = 11111;
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/b/mutations.js